import React from 'react';
import './expand-title.scss';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import { FacebookShareButton } from 'react-share';
import EmailShareButton from '../../../common/social-share-button/EmailShareButton';
import SkypeShareButton from '../../../common/social-share-button/SkypeShareButton';
import ZaloShareButton from '../../../common/social-share-button/ZaloShareButton';
import { getNewsUrl } from '../../../helpers/Common';

class ExpandTitle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowExpand: true,
      isShowShare: false,
    };
    this.shareRef = React.createRef();
  }

  getColor = value => {
    if (value > 0) return '#00de8b';
    if (value < 0) return '#eb505a';
    return 'ffffff';
  };

  getType = value => {
    if (value > 0) return '+';
    return '';
  };

  getShareWidth = () => {
    const { isShowShare } = this.state;
    const { fontSize } = this.props;
    if (!isShowShare) {
      return 0;
    }
    const mapWidth = {
      Small: 66,
      Medium: 73,
      Large: 87,
    };

    return mapWidth[fontSize];
  };

  getWidth = () => {
    const { width } = this.props;

    return width - 20 - this.getShareWidth(); // minus padding td
  };

  getStyle = () => {
    const width = this.getWidth();

    return {
      cursor: 'pointer',
      whiteSpace: 'nowrap',
      width: width,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: 'block',
    };
  };

  onMouseEnter = () => {
    this.setState({
      isShowShare: true,
    });
  };

  onMouseLeave = () => {
    this.setState({
      isShowShare: false,
    });
  };

  render() {
    const {
      item: { newsShortContent, newsTitle, newsId, newsSourceLink },
      width,
      locale,
    } = this.props;
    const { isShowExpand, isShowShare } = this.state;
    if (!width) {
      return null;
    }
    const newsUrl = newsSourceLink || getNewsUrl(locale, newsId);
    const className = `content-expand ${isShowExpand ? 'show' : ''}`;

    return (
      <div
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        className="d-flex"
      >
        <div className="text-left expand-title-wrap">
          <div className="header-title">
            <a href={`#${newsId}`} style={this.getStyle()}>
              {newsTitle}
            </a>
          </div>
          <div className={className}>
            <div className="content-des text-l-color-1">
              <div
                style={{
                  WebkitBoxOrient: 'vertical',
                }}
                className="news-short-content"
              >
                {newsShortContent}
              </div>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={newsUrl}
                className="ml-1"
                style={{ paddingLeft: 0, color: '#47c3ff', fontWeight: 600 }}
              >
                {I18n.t('watchListNews.readMore')}
              </a>
            </div>
          </div>
        </div>
        <div
          ref={this.shareRef}
          className={isShowShare ? 'share-sns' : 'share-sns d-none'}
        >
          <span>Share</span>&nbsp;
          <FacebookShareButton url={newsUrl}>
            <i className="icon-facebook" />
          </FacebookShareButton>
          &nbsp;
          <ZaloShareButton url={newsUrl}>
            <i className="icon-zalo" />
          </ZaloShareButton>
          &nbsp;
          <SkypeShareButton url={newsUrl}>
            <i className="icon-skype" />
          </SkypeShareButton>
          &nbsp;
          <EmailShareButton url={newsUrl}>
            <i className="icon-gmail" />
          </EmailShareButton>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  locale: state.i18n.locale,
  fontSize: state.fontSize,
});

export default connect(mapStateToProps)(ExpandTitle);
